import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  PrimaryButton,
  DefaultButton,
} from 'office-ui-fabric-react/lib/Button';

export const FooterContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  > button:not(:last-child) {
    margin-right: 5px;
  }

  @media screen and (max-width: 321px) {
    flex-flow: row wrap;
    > button {
      margin: 0 5px 5px 0;
      width: 47%;
    }
  }
`;

const PanelFooter = ({
  saveBtnLabel,
  closeBtnLabel,
  onSave,
  onClose,
  saveDisabled,
}) => (
  <FooterContainer>
    <PrimaryButton onClick={onSave} disabled={saveDisabled}>
      {saveBtnLabel || 'Submit'}
    </PrimaryButton>
    <DefaultButton onClick={onClose}>{closeBtnLabel || 'Close'}</DefaultButton>
  </FooterContainer>
);

PanelFooter.propTypes = {
  saveBtnLabel: PropTypes.string,
  closeBtnLabel: PropTypes.string,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
};

export default PanelFooter;



// WEBPACK FOOTER //
// ./src/app/components/PanelFooter/index.jsx